import { ObjectField, Test, TestType } from "../../parser/models/all.js";
import { getTitle, hasTitle } from "../../parser/utils/testTitleUtils.js";
import { PreProcessContext } from "../models/preProcessContext.js";
import { getChildGroupName, processChildObjectFields } from "./preProcessUtils.js";

/**
 * Processor for identifying plain objects and recursively extracting tests from their properties.
 * 
 * @param field - The object field containing the object.
 * @param index - Field index in the collection.
 * @param context - The pre-processing context.
 * @returns True if the field was processed as an object group.
 */
export function processObject(field: ObjectField, index: number, context: PreProcessContext): boolean {
  let { name, value } = field;

  if (value instanceof Object) {
    const options = context.options;
    const isObjectWithTitle = hasTitle(value, options);

    const nameOrTitle = isObjectWithTitle
      ? getTitle(value, options) as string
      : name;

    const objectTestProp = new Test(
      field.groupName,
      nameOrTitle,
      value,
      new TestType(TestType.OBJECT),
      // test cases
      [],
      // only expression
      ""
    );

    context.tests.push(objectTestProp);

    // process children
    const testProps = processChildObjectFields(
      getChildGroupName(objectTestProp.groupName, nameOrTitle),
      value,
      options
    );

    context.tests.push(
      ...testProps
    );

    return true;
  }

  return false;
}
